<template>
  <div>
    <div class="home">
      <van-nav-bar title="合作伙伴" left-text="返回" @click-left="onClickLeft" fixed/>
      <div class="navheight"></div>
      <div class="content">
        <div class="nongmu_cont">
          <div class="contentTie">
            <img src="../../assets/joinusimg/companylogo/yongcheng.png" alt="">
            <div class="company">福建永诚农牧科技集团有限公司</div>
          </div>
          <div class="labInfo">
            <span>二十七年</span>
            <span>永诚·长速快</span>
            <span>永不止步</span><br/>
            <span>诚心服务</span>
          </div>
          <div class="companyInfo">
            <img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/422060668302254217.jpg" alt="">
            <div class="companyWord">&nbsp; &nbsp; &nbsp; &nbsp;福建永诚农牧科技集团有限公司诞生于1992年，是农业部首批“国家生猪核心育种场”之一，在国内首批获得国家级认证“猪伪狂犬病净化示范场”。集团旗下有四家种猪育种子公司和一家养猪设备公司，专业从事瘦肉型良种猪育种、培育研究及推广工作。<br/> &nbsp; &nbsp; &nbsp; &nbsp;二十七年来，永诚以“引领种猪育种，改善人类营养”为使命，不断完善创新种猪育种的核心技术。现共建设有福建省院士工作站和专家工作站两个科研平台，通过对猪的数量遗传育种，结合全基因组检测等分子育种手段对种猪进行育种和研究，已打破制约我国种猪发展的“引种-繁育-退化-再引种的怪圈”。<br/> &nbsp; &nbsp; &nbsp; &nbsp;永诚秉承“永不止步，诚心服务”的企业宗旨，将企业建设成中国一流的种猪育种集团公司，更好地服务于社会。</div>
            <img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/j1.jpg" alt="">
            <img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/j2.jpg" alt="">
            <img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/j3.jpg" alt="">
            <img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/j4.jpg" alt="">
          </div>
        </div>
      </div>
      <div class='bottom'>
        <div class="title">经营范围</div>
        <div class="info">全国</div>
      </div>
      <footer class="nongmu-footer">
        <dl>
          <dt><img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/wangzhi@3x.png" alt=""></dt><dd><a href="http://www.ycxm.com/">http://www.ycxm.com/</a></dd>
        </dl>
        <dl>
          <dt><img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/dizhi@3x.png" alt=""></dt><dd>(总公司)福建永诚农牧科技集团有限公司：福建省福清市音西街道融商大厦A区2105</dd>
        </dl>
        <dl>
          <dt><img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/dizhi@3x.png" alt=""></dt><dd>福清市永诚畜牧有限公司：福建省福清市高山镇薛港村坑北106号</dd>
        </dl>
        <dl>
          <dt><img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/dizhi@3x.png" alt=""></dt><dd>江西永诚农牧有限公司：江西省上饶市鄱阳县凰岗镇杨源村委会鲁家村</dd>
        </dl>
        <dl>
          <dt><img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/dizhi@3x.png" alt=""></dt><dd>贵州永诚农牧有限公司：贵州省锦屏县铜鼓镇乐安村永诚大道</dd>
        </dl>
        <dl>
          <dt><img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/dizhi@3x.png" alt=""></dt><dd>福建诚多农牧设备有限公司：福建省福建省福清市高山镇薛港工业小区</dd>
        </dl>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'partner',
  methods: {
    onClickLeft() {
      this.$router.back(-1)
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../assets/style/partner.scss';
</style>
